module.exports = __webpack_public_path__ + "static/media/kevin-huang.d1a5e165.jpeg";